import { render, staticRenderFns } from "./DialogHistoricoAlteracoesMaquinas.vue?vue&type=template&id=4b2b27af"
import script from "./DialogHistoricoAlteracoesMaquinas.vue?vue&type=script&lang=js"
export * from "./DialogHistoricoAlteracoesMaquinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports